import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import ShowIcon from "@mui/icons-material/Add";
import HideIcon from "@mui/icons-material/Remove";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import SendPharmacyIcon from "../../images/icons/SendPharmacyIcon.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  BtnIconStyle,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  DRxTextareaStyle,
  HtmlTooltip,
  RxBox,
  ScrollBarStyle,
  SummaryInfo,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import { Form, Formik } from "formik";
import ConfirmPopup from "../../components/ConfirmPopup";
import PendingRefillsTab from "../../components/PendingRefillsTab";
import DRxInput from "../../uikit/DRxInput";
import DRxTextarea from "../../uikit/DRxTextarea";
import DRxSelect from "../../uikit/DRxSelect";
import {
  PendingRefillsDetails,
  PendingRefillsReplace,
  PendingRefillsSendToPharmacy,
  RemovePendingRefillsById,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import PendingRefillsAllergyInfo from "./PendingRefillsAllergyInfo";
import { useDispatch, useSelector } from "react-redux";
import { loadingTopRibbon } from "../../Redux/Slice/TopRibbonSlice";
import { Collapse } from "@mui/material";
import DrugAllergyInteractions from "../../components/DrugAllergyInteractions";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import YSCheckBox from "../../uikit/YSCheckBox";
import { Tooltip } from "@mui/material";

export default function PendingRefillsRequest(props: any) {
  const AllDropdwonsState = useSelector((State: any) => {
    return { ...State.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const navigate = useNavigate();
  //const { state }: any = useLocation();
  const [activeRefillsTabClass, setActiveRefillsTabClass] = useState(false);
  const [sendToPharmacyData, setSendToPharmacyData] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [deleteData, setDeleteData] = useState("");
  const [initialValues, setInitialValues] = useState<any>([]);
  const [openInfo, setOpenInfo] = useState<boolean[]>([]);
  const handleInfoClick = (index: number): void => {
    setOpenInfo((openInfo) => {
      const newOpenInfo = [...openInfo];
      newOpenInfo[index] = !newOpenInfo[index];
      return newOpenInfo;
    });
  };

  const [load, setLoad] = useState<boolean[]>([]);

  const handleClickLoad = (index: number): void => {
    setLoad((prevState) => {
      const newLoad = [...prevState];
      newLoad[index] = !newLoad[index];
      return newLoad;
    });
  };

  const dispatch = useDispatch();
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);

  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
    navigate("/pendingrefills");
  };

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("refillId", deleteData);
      const result = await RemovePendingRefillsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getRefillsDetails();
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getRefillsDetails = async () => {
    try {
      const patientId = JSON.parse(
        localStorage.getItem("pendingrefillsrequest-data")!
      )?.patientId;
      const doctorId = JSON.parse(
        localStorage.getItem("pendingrefillsrequest-data")!
      )?.doctorId;

      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("patientId", patientId);
      const result = await PendingRefillsDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        let InitialJson: any = [];
        result?.data?.response?.map((item: any, index: any) => {
          return InitialJson.push({
            reasonDenied: "0",
            actionType: "0",
            Notes: "",
            refills: item.refills ?? "",
            initiateEpa: true,
          });
        });

        setInitialValues(InitialJson);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (err) {
      setData([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    getRefillsDetails();
    setActiveRefillsTabClass(false);
    return () => {
      localStorage.removeItem("pendingrefillsrequest-data");
    };
  }, []);

  const pendingRefillReplaceAPI = async (eachItem: any, index: any) => {
    try {
      handleClickLoad(index);
      const bodyData = {
        refillId: eachItem?.personRefillId,
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: localStorage.getItem("doctorId"),
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await PendingRefillsReplace(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        //localStorage.setItem("patientId", eachItem?.personId);
        handleClickLoad(index);
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify([result?.data?.response[0]?.prescriptionForm])
        );
        sessionStorage.setItem(
          "rxHubOptions",
          JSON.stringify(
            result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueIdOptions
          )
        );
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
        );
        dispatch(loadingPharmacyDropDown());
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        navigate("/newrxpad");
      } else {
        handleClickLoad(index);
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      handleClickLoad(index);
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after sometime",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const pharmacyRefillsSendToPharmacy = async (
    eachItem: any,
    values: any,
    index: any
  ) => {
    if (values[index].actionType === "DENIED_NEW_RX") {
      pendingRefillReplaceAPI(eachItem, index);
    } else {
      try {
        handleClickLoad(index);
        const patientId = JSON.parse(
          localStorage.getItem("pendingrefillsrequest-data")!
        )?.patientId;
        const doctorId = JSON.parse(
          localStorage.getItem("pendingrefillsrequest-data")!
        )?.doctorId;
        const bodyData = {
          doctorId: localStorage.getItem("doctorId"),
          prescriberAgentId:
            localStorage.getItem("doctorId") == doctorId ? "" : doctorId, //state?.rowData?.patientId ?? patientId,
          patientId: patientId, // state?.rowData?.patientId ?? patientId,
          personRefillId: eachItem?.personRefillId,
          notes: values[index].Notes,
          refillAction:
            values[index].actionType === "0" ? "" : values[index].actionType,
          denialReason:
            values[index].reasonDenied === "0"
              ? ""
              : values[index].reasonDenied,
          refillCount: values[index]?.refills,
          selectedAddress: sessionStorage.getItem("clinicId"),
        };
        const params = new URLSearchParams();
        params.append(
          "paInitiationFlag",
          eachItem?.epaPrescription && eachItem?.epaAuthValid === false
            ? values[index].initiateEpa
            : "false"
        );
        const result = await PendingRefillsSendToPharmacy(params, bodyData);
        if (result?.data?.digitalRxStatusCode === 200) {
          setApprovedPopup(true);
          setSendToPharmacyData(result?.data?.response[0]);
          dispatch(loadingTopRibbon());

          handleClickLoad(index);
        } else {
          setSendToPharmacyData({});

          handleClickLoad(index);
          setDeleteStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.digitalRxStatusMessage,
              variant: "error",
              open: true,
            };
          });
        }
      } catch (error) {
        setSendToPharmacyData({});

        handleClickLoad(index);
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: "Something went wrong!",
            variant: "error",
            open: true,
          };
        });
      }
    }
  };

  // useEffect(() => {
  //   localStorage.setItem("rowData", JSON.stringify(state?.rowData));
  // }, []);
  return (
    <>
      <PendingRefillsTab
        activeRefillsTabClass={activeRefillsTabClass}
        setActiveRefillsTabClass={setActiveRefillsTabClass}
      />
      <ContentStyle>
        {activeRefillsTabClass ? (
          <PendingRefillsAllergyInfo patientId={data[0]?.personId} />
        ) : (
          <>
            {loading ? (
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            ) : (
              <ScrollBarStyle className="full">
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values) => {
                    console.log(values);
                  }}
                >
                  {(registerProps) => (
                    <Form onSubmit={registerProps.handleSubmit}>
                      {data?.map((eachItem: any, index: any) => (
                        <RxBox>
                          <Box
                            className={
                              eachItem?.deaClassCode
                                ? "titles schdrug"
                                : "titles"
                            }
                          >
                            <Typography component="div" variant="body2">
                              {eachItem?.drugDescription}
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.deaClassCode}
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.sig}
                            </Typography>
                          </Box>
                          <Box className="content">
                            <Box className="full">
                              <Typography
                                variant="body2"
                                component="label"
                                color="error"
                              >
                                {eachItem?.errorMessage}
                              </Typography>
                            </Box>
                            <Box className="col1">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Quantity
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                {eachItem?.quantity}
                              </Typography>
                            </Box>{" "}
                            <Box className="col2">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Substitutions
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                {eachItem?.substitution}
                              </Typography>
                            </Box>
                            <Box className="col3">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Days Supply:
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                {eachItem?.daysSupply}
                              </Typography>
                            </Box>
                            <Box className="col1">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Qualifier
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                {eachItem?.quantityQualifier}
                              </Typography>
                            </Box>
                            <Box className="col2 input">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Total number of dispensings approved:
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                <DRxInputStyle className="w100">
                                  <DRxInput
                                    aria-describedby="component-error-text"
                                    id="total"
                                    name={`${index}.refills`}
                                    type={"number"}
                                    className=""
                                    disabled={false}
                                    values={
                                      registerProps?.values[index]?.refills
                                    }
                                  />
                                </DRxInputStyle>
                              </Typography>
                            </Box>
                            <Box className="col3">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Pharmacy
                              </Typography>
                              <Typography component="div" variant="body2">
                                {eachItem?.pharmacyName}
                                <HtmlTooltip
                                  placement="bottom"
                                  arrow
                                  title={
                                    <PharmacyDetails
                                      row={eachItem?.pharmacyDetails}
                                    />
                                  }
                                  className="w316"
                                >
                                  <IconButton className="tooltip">
                                    <img
                                      src={InfoIcon}
                                      alt="Tooltip"
                                      loading="lazy"
                                    />
                                  </IconButton>
                                </HtmlTooltip>
                              </Typography>
                            </Box>
                            <Box className="col1" style={{ display: "block" }}>
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Notes:
                              </Typography>
                              <Typography component="div" variant="body2">
                                <DRxTextareaStyle className="note">
                                  <DRxTextarea
                                    type="textarea"
                                    label={"Notes"}
                                    name={`${index}.Notes`}
                                    id={"notes"}
                                    className={""}
                                    placeholder="Enter notes"
                                  />
                                </DRxTextareaStyle>
                              </Typography>
                            </Box>
                            <Box className="col2" style={{ display: "block" }}>
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Note From Pharmacy:
                              </Typography>
                              <Typography component="div" variant="body2">
                                {eachItem?.pharmacyNote}
                              </Typography>
                            </Box>
                            <Box
                              className="col3"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography component="div" variant="body2">
                                Prescribed Drug Info{" "}
                                <HtmlTooltip
                                  placement="bottom"
                                  arrow
                                  title={
                                    <PrescribedDrugInfo
                                      row={eachItem?.prescribedDrugInfo}
                                    />
                                  }
                                  className="w316"
                                >
                                  <IconButton className="tooltip">
                                    <img
                                      src={InfoIcon}
                                      alt="Tooltip"
                                      loading="lazy"
                                    />
                                  </IconButton>
                                </HtmlTooltip>
                              </Typography>
                              {eachItem?.epaPrescription && (
                                <Typography
                                  component="div"
                                  variant="body2"
                                  display={"flex"}
                                  flexDirection={"row"}
                                  justifyContent={"space-around"}
                                  alignItems={"center"}
                                >
                                  <Typography
                                    bgcolor={
                                      eachItem?.epaAuthInValid
                                        ? "#fcaca7"
                                        : eachItem?.epaPrescription &&
                                          eachItem?.epaAuthValid
                                        ? "#82f5a0"
                                        : eachItem?.epaPrescription &&
                                          !eachItem?.epaAuthValid &&
                                          "#fccf8b"
                                    }
                                    component="div"
                                    variant="body2"
                                    borderRadius={5}
                                    paddingX={1}
                                    paddingY={0.5}
                                    border={
                                      eachItem?.epaAuthInValid
                                        ? "1px solid red"
                                        : eachItem?.epaPrescription &&
                                          eachItem?.epaAuthValid
                                        ? "1px solid green"
                                        : eachItem?.epaPrescription &&
                                          !eachItem?.epaAuthValid &&
                                          "1px solid orange"
                                    }
                                  >
                                    {eachItem?.epaAuthInValid ? (
                                      <>PA Invalid</>
                                    ) : eachItem?.epaPrescription &&
                                      eachItem?.epaAuthValid ? (
                                      <>PA valid</>
                                    ) : (
                                      eachItem?.epaPrescription &&
                                      !eachItem?.epaAuthValid && <>PA Expired</>
                                    )}
                                  </Typography>
                                  <HtmlTooltip
                                    placement="bottom"
                                    arrow
                                    title={
                                      <EpaPrescriptionDetails row={eachItem} />
                                    }
                                    className="w316"
                                  >
                                    <IconButton className="tooltip">
                                      <img
                                        src={InfoIcon}
                                        alt="Tooltip"
                                        loading="lazy"
                                      />
                                    </IconButton>
                                  </HtmlTooltip>
                                  {(eachItem?.epaPrescription &&
                                    eachItem?.epaAuthValid) === false && (
                                    <YSCheckBox
                                      name={`${index}.initiateEpa`}
                                      label={"Initiate EPA"}
                                    />
                                  )}
                                </Typography>
                              )}
                            </Box>
                            <Box className="col1">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Last Filled Date:
                              </Typography>
                              <Typography component="div" variant="body2">
                                {eachItem?.lastFillDate}
                              </Typography>
                            </Box>
                            <Box className="col2">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Written Date:
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                {eachItem?.writtenDate}
                              </Typography>
                            </Box>
                            {/* <Box className="col3"></Box> */}
                            <Box className="col3 select">
                              <Typography
                                component="label"
                                variant="subtitle1"
                                color={"primary"}
                                fontWeight={600}
                              >
                                Action:
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                <DRxSelectStyle className="w100">
                                  <DRxSelect
                                    name={`${index}.actionType`}
                                    id="actionType"
                                    data={eachItem?.actions}
                                    label="actionType"
                                  />
                                </DRxSelectStyle>
                              </Typography>
                            </Box>
                            <Box className="col2 select">
                              <Typography
                                component="label"
                                variant="body2"
                                fontWeight={600}
                              >
                                Denial reason:
                              </Typography>{" "}
                              <Typography component="div" variant="body2">
                                <DRxSelectStyle>
                                  <DRxSelect
                                    name={`${index}.reasonDenied`}
                                    id="reasonDenied"
                                    data={
                                      AllDropdwonsState?.denialReasonsForRefillsOptions ?? [
                                        { label: "", value: "" },
                                      ]
                                    }
                                  />
                                  {/* <YSSelectSearch
                                    name={`${index}.reasonDenied`}
                                    id="reasonDenied"
                                    options={
                                      AllDropdwonsState?.denialReasonsForRefillsOptions ?? [
                                        { label: "", value: "" },
                                      ]
                                    }
                                    label="reasonDenied"
                                    onChange={(option: any, e: any) => {
                                      registerProps.setFieldValue(
                                        `${index}.reasonDenied`,
                                        e.value
                                      );
                                    }}
                                  /> */}
                                </DRxSelectStyle>{" "}
                              </Typography>
                            </Box>
                            <Box className="col3">
                              <YSButton
                                children={
                                  load[index] ? (
                                    <CircularProgress
                                      size={28}
                                      color={"inherit"}
                                    />
                                  ) : (
                                    "Send to Pharmacy"
                                  )
                                }
                                size={"medium"}
                                type="submit"
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                  pharmacyRefillsSendToPharmacy(
                                    eachItem,
                                    registerProps?.values,
                                    index
                                  );
                                }}
                                startIcon={
                                  <img
                                    src={SendPharmacyIcon}
                                    alt="Send to Pharmacy"
                                    loading="lazy"
                                  />
                                }
                              />
                              <BtnIconStyle>
                                <Tooltip title="Delete">
                                  <IconButton
                                    type="button"
                                    className="trash"
                                    onClick={() => {
                                      handleShowDeletePopupClick();
                                      setDeleteData(eachItem?.personRefillId);
                                    }}
                                  >
                                    <img
                                      src={TrashIcon}
                                      alt="Delete"
                                      loading="lazy"
                                    />
                                  </IconButton>
                                </Tooltip>
                              </BtnIconStyle>
                            </Box>
                          </Box>
                          {registerProps.values[index].actionType ===
                            "APPROVED" && (
                            <SummaryInfo style={{ margin: "2px" }}>
                              {" "}
                              <Grid
                                container
                                item
                                xs={12}
                                spacing={1}
                                alignItems="center"
                                justifyContent="flex-start"
                              >
                                <Grid item xs={9} md={6}>
                                  <Typography
                                    component="div"
                                    color={"primary"}
                                    variant="subtitle2"
                                    fontWeight={600}
                                  >
                                    Allergy and Drug Interactions
                                  </Typography>{" "}
                                </Grid>
                                <Grid item xs={3} md={6} textAlign={"right"}>
                                  <YSButton
                                    key={index}
                                    onClick={() => handleInfoClick(index)}
                                    className=""
                                    children={"Show"}
                                    size={"small"}
                                    type="button"
                                    variant="contained"
                                    startIcon={
                                      openInfo[index] ? (
                                        <HideIcon />
                                      ) : (
                                        <ShowIcon />
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <Collapse in={openInfo[index]}>
                                    <DrugAllergyInteractions
                                      key={index}
                                      eachData={eachItem}
                                    />
                                  </Collapse>
                                </Grid>
                              </Grid>{" "}
                            </SummaryInfo>
                          )}
                        </RxBox>
                      ))}
                    </Form>
                  )}
                </Formik>
              </ScrollBarStyle>
            )}
          </>
        )}
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {sendToPharmacyData?.status ? (
            <Grid item xs={12} textAlign={"center"} marginTop={1}>
              <CheckCircleOutlineIcon
                style={{ height: 70, width: 70 }}
                color="success"
              />
            </Grid>
          ) : (
            <Grid item xs={12} textAlign={"center"}>
              <CancelOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="error"
              />
            </Grid>
          )}
          <Grid item xs={12} textAlign={"center"}>
            <Typography
              color="primary"
              component="span"
              variant="subtitle1"
              fontWeight={600}
            >
              {sendToPharmacyData?.operation}
            </Typography>{" "}
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <Typography component="span" variant="subtitle2" fontWeight={600}>
              {sendToPharmacyData?.message}
            </Typography>{" "}
          </Grid>
        </Grid>{" "}
      </DialogPopup>

      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
const PrescribedDrugInfo = (props: any) => {
  const { row } = props;
  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        Medication Prescribed
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Drug Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.drugDescription)
              ? "Not Available"
              : row?.drugDescription}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Qualifier:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.quantityQualifier)
              ? "Not Available"
              : row?.quantityQualifier}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Quantity:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.quantity)
              ? "Not Available"
              : row?.quantity}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Total no.of dispensing requested:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.refills) ? "Not Available" : row?.refills}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Notes:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.notes) ? "Not Available" : row?.notes}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Substitution:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.substitution)
              ? "Not Available"
              : row?.substitution}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Directions:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.instructions)
              ? "Not Available"
              : row?.instructions}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Written Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.writtenDate)
              ? "Not Available"
              : row?.writtenDate}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyName)
            ? "Not Available"
            : row?.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.twentyFourHourFlag)
            ? "Not Available"
            : row?.twentyFourHourFlag}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.storeNo) ? "Not Available" : row?.storeNo}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyAddress)
            ? "Not Available"
            : row?.pharmacyAddress}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.landmark) ? "Not Available" : row?.landmark}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.city) ? "Not Available" : row?.city}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.state) ? "Not Available" : row?.state}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.zip) ? "Not Available" : row?.zip}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.pharmacyPhone)
            ? "Not Available"
            : row?.pharmacyPhone}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row?.faxNo) ? "Not Available" : row?.faxNo}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const EpaPrescriptionDetails = (props: any) => {
  const { row } = props;

  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        EPA Prescription Details
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={4}>
        <Grid item xs={12} md={5}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Status:
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.epaPrescriptionDetailsForRefills?.status)
              ? "Not Available"
              : row?.epaPrescriptionDetailsForRefills?.status}
          </Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            PA Note:
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row?.epaPrescriptionDetailsForRefills?.paNote)
              ? "Not Available"
              : row?.epaPrescriptionDetailsForRefills?.paNote}
          </Typography>
        </Grid>

        {row?.epaPrescription && !row?.epaAuthValid && !row?.epaAuthInValid && (
          <>
            <Grid item xs={12} md={5}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Auth Expiry Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography component={"div"} variant={"body2"}>
                {[null, ""].includes(
                  row?.epaPrescriptionDetailsForRefills?.paAuthExpiryDate
                )
                  ? "Not Available"
                  : row?.epaPrescriptionDetailsForRefills?.paAuthExpiryDate}
              </Typography>
            </Grid>
          </>
        )}
        {row?.epaPrescription && row?.epaAuthValid && (
          <>
            <Grid item xs={12} md={5}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Auth Effective Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography component={"div"} variant={"body2"}>
                {[null, ""].includes(
                  row?.epaPrescriptionDetailsForRefills?.paAuthEffectiveDate
                )
                  ? "Not Available"
                  : row?.epaPrescriptionDetailsForRefills?.paAuthEffectiveDate}
              </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Auth Expiry Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography component={"div"} variant={"body2"}>
                {[null, ""].includes(
                  row?.epaPrescriptionDetailsForRefills?.paAuthExpiryDate
                )
                  ? "Not Available"
                  : row?.epaPrescriptionDetailsForRefills?.paAuthExpiryDate}
              </Typography>
            </Grid>

            <Grid item xs={12} md={5}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Authorization Number:
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography component={"div"} variant={"body2"}>
                {[null, ""].includes(
                  row?.epaPrescriptionDetailsForRefills?.paAuthorizationNumber
                )
                  ? "Not Available"
                  : row?.epaPrescriptionDetailsForRefills
                      ?.paAuthorizationNumber}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};
